var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2226 1.95049L13.2227 1.95055L13.2267 1.94427C13.5199 1.47848 13.3801 0.86313 12.9143 0.569853C12.4497 0.277348 11.8364 0.415694 11.5422 0.878547L6.05783 8.98928L2.50535 4.81898C2.14841 4.39997 1.51938 4.34964 1.10037 4.70658C0.681356 5.06352 0.631034 5.69255 0.98797 6.11156L5.41254 11.3056C5.61818 11.547 5.92644 11.6762 6.24275 11.6534C6.55773 11.6307 6.84325 11.4602 7.01249 11.1937L13.2226 1.95049Z",
    fill: "#AAAAAA",
    stroke: "#AAAAAA",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkIconGrey);
export default __webpack_public_path__ + "static/media/checkmark_icon_grey.a1d8e5f11483cf20ef6f182a8ddec161.svg";
export { ForwardRef as ReactComponent };